import classNames from "classnames"
import { useState } from "react"
import { Card, CardBody } from "reactstrap"

import { SupporterRole } from "@api/schema"
import ActionIcon from "@components/common/ActionIcon"
import { withDynamicNamespaces } from "@components/hoc/withDynamicNamespaces"
import { NamespaceShortcut, useDynamicTranslation } from "@services/i18n"

const usedNamespaces: NamespaceShortcut[] = ["partner-market", "supportRequest"]

interface IProps {
  chosen: boolean
  supporterRole: SupporterRole
  onChoice: (role: SupporterRole) => void
  onCancel: () => void
}

/**
 * This component provides a card for a SupporterRole, that may be chosen when creating a SupportRequest
 */
const SupporterRoleCard: React.FC<IProps> = (props: IProps) => {
  const t = useDynamicTranslation()
  const { chosen = false, supporterRole, onChoice, onCancel } = props

  const [mouseOver, setMouseOver] = useState(false)
  const [hasFocus, setHasFocus] = useState(false)

  const cardBodyClassName = classNames(
    { "clickable": !chosen },
    { "text-gray": !mouseOver && !chosen && !hasFocus }
  )

  return <Card
    className="supporter-role-card"
    onMouseEnter={() => setMouseOver(true)}
    onMouseLeave={() => setMouseOver(false)}
    onClick={() => !chosen && onChoice(supporterRole)}
    onKeyDown={(event) => (event.key === "Enter" && !chosen) && onChoice(supporterRole)}
    onFocus={() => setHasFocus(true)}
    onBlur={() => setHasFocus(false)}
    title={t("supportRequest", "supporterRole." + supporterRole)}
    tabIndex={!chosen ? 0 : undefined}
  >
    <CardBody className={cardBodyClassName}>
      {chosen && <ActionIcon
        title={t("common", "form.cancel")}
        icon="cancel"
        onclick={onCancel}
      />}
      {t("partner-market", "searchingFor." + supporterRole)}
    </CardBody>
  </Card>
}

export default withDynamicNamespaces<IProps>(SupporterRoleCard, usedNamespaces)
